import { render, staticRenderFns } from "./TransactionStats.vue?vue&type=template&id=379b10b2&scoped=true&"
import script from "./TransactionStats.vue?vue&type=script&lang=js&"
export * from "./TransactionStats.vue?vue&type=script&lang=js&"
import style0 from "./TransactionStats.vue?vue&type=style&index=0&id=379b10b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379b10b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VDivider,VProgressLinear})
